import * as FingerprintJS from '../src'

type Text = string | { html: string }

async function getVisitorData() {
  const fp = await FingerprintJS.load({ debug: true })
  return await fp.get()
}

async function startPlayground() {
  const output = document.querySelector('.output')
  if (!output) {
    throw new Error("The output element isn't found in the HTML code")
  }
  try {
    const { visitorId} = await getVisitorData()
    output.innerHTML = ''
    addOutputSection({ output, content: visitorId })
  } catch (error) {
    throw error
  }
}

function addOutputSection({
  output,
  content,
}: {
  output: Node
  content: Text
}) {
  
  const contentElement = document.createElement('input')
  contentElement.setAttribute("Type","hidden")
  contentElement.setAttribute("id","Uid")
    contentElement.setAttribute("name","Uid")
  contentElement.setAttribute("value",content as string)
  contentElement.appendChild(textToDOM(content))
  output.appendChild(contentElement)
}


function textToDOM(text: Text): Node {
  if (typeof text === 'string') {
    return document.createTextNode(text)
  }
  const container = document.createElement('div')
  container.innerHTML = text.html
  const fragment = document.createDocumentFragment()
  while (container.firstChild) {
    fragment.appendChild(container.firstChild)
  }
  return fragment
}

startPlayground()